import classNames from "classnames";
import s from "./Booble.module.css";

export const Booble = ({
  children,
  subtitle,
  color,
  text = "center",
  style,
  padding = "small",
  className,
}) => {
  const classNameIn = classNames(
    s.booble,
    s[color],
    s[padding],
    s[text],
    { [s.spaceBetween]: subtitle },
    className
  );
  return (
    <span {...{ className: classNameIn, style }}>
      <span className={s.subtitle}>{subtitle}</span>
      {children}
    </span>
  );
};
